import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import { FormSection } from 'components';
import { LLTextField } from 'components/FormElements';
var UserAccountForm = (_dec = connect(function (state) {
  return {
    user: state.auth.user
  };
}, {}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(UserAccountForm, _Component);

  var _super = _createSuper(UserAccountForm);

  function UserAccountForm() {
    var _this;

    _classCallCheck(this, UserAccountForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (_ref) {
      var input = _ref.input,
          placeholder = _ref.placeholder,
          type = _ref.type,
          className = _ref.className,
          _ref$meta = _ref.meta,
          active = _ref$meta.active,
          touched = _ref$meta.touched,
          error = _ref$meta.error;
      return /*#__PURE__*/React.createElement(LLTextField, _extends({}, input, {
        placeholder: placeholder,
        type: type,
        className: className,
        id: input.name,
        errorText: !active && touched && error && /*#__PURE__*/React.createElement("span", null, error),
        style: {
          width: '100%'
        }
      }));
    });

    return _this;
  }

  _createClass(UserAccountForm, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement(FormSection, {
        title: "Password",
        titleStyle: {
          marginBottom: 0
        }
      }, /*#__PURE__*/React.createElement(Field, {
        name: "password",
        type: "password",
        component: this.renderInput,
        placeholder: "New Password",
        className: "form-control"
      }), /*#__PURE__*/React.createElement(Field, {
        name: "confirmPassword",
        type: "password",
        component: this.renderInput,
        placeholder: "Confirm New Password",
        className: "form-control"
      })));
    }
  }]);

  return UserAccountForm;
}(Component)) || _class);
export { UserAccountForm as default };